import styled from 'styled-components';

export default styled.h4`
  font-family: var(--google-sora-cdn);
  font-size: 25px;
  margin: 0 0 25px;
  text-align: center;
`;
